var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.truncateTitle && 'truncate-title',domProps:{"innerHTML":_vm._s(_vm.sanitizedArticleTitle)}})
}
var staticRenderFns = []

export { render, staticRenderFns }